module.exports = __webpack_public_path__ + "img/clock2.dcbb8646.svg";